"use strict";

var debounce = require("lodash/debounce");
var lazyLoading = require("../global/lazyLoading");
var endpoint = $(".suggestions-wrapper").data("url");
var minChars = $(".l-header__search-field").data("searchsuggestionslength");
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
var SEARCH_STATUS_REGION_ID = "search-suggestions-status";

/**
 * Ensure a hidden live region exists for search status announcements.
 *
 * @return {JQuery} - Live region element
 */
function getSearchStatusRegion() {
    var $statusRegion = $("#" + SEARCH_STATUS_REGION_ID);

    if (!$statusRegion.length) {
        $statusRegion = $("<div>", {
            id: SEARCH_STATUS_REGION_ID,
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true",
            "aria-hidden": "false",
            style: "position:absolute;left:-9999px;width:1px;height:1px;overflow:hidden;"
        });

        $("body").append($statusRegion);
    }

    return $statusRegion;
}

/**
 * Announce search suggestion updates to assistive technologies.
 * Remounts the live region so the AT treats it as a fresh node and reliably speaks it.
 *
 * @param {string} message - Status message to announce
 */
function announceSearchStatus(message) {
    getSearchStatusRegion().remove();

    var $statusRegion = getSearchStatusRegion();

    window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
            $statusRegion.text(message || "");
        });
    });
}

/**
 * Keeps the input's aria-expanded/aria-controls in sync with the popup so refocus
 * announces the real state instead of a stale collapsed listbox hint.
 *
 * @param {Object} scope - Search input field DOM element
 * @param {boolean} isOpen - Whether the suggestions popup is open
 */
function updateSearchPopupState(scope, isOpen) {
    var $searchField = $(scope);

    if (!$searchField.length) {
        return;
    }

    $searchField.attr("aria-expanded", isOpen ? "true" : "false");

    if (isOpen) {
        $searchField.attr("aria-controls", "search-results");
    } else {
        $searchField.removeAttr("aria-controls");
        $searchField.removeAttr("aria-activedescendant");
    }
}

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    if ($(scope).closest(".site-search").length > 0) {
        return $(".l-header .suggestions-wrapper");
    }

    return $(scope).parent().siblings(".suggestions-wrapper");
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest(".search-mobile").length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    let $minicartPopover = $(".minicart-popover");

    if ($minicartPopover.length && $minicartPopover.hasClass("show")) {
        $minicartPopover.find(".js-minicart-close").trigger("click");
    }

    $("body").removeClass("modal-open");
    $("header").siblings().attr("aria-hidden", "false");
    $(".suggestions").removeClass("modal");
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $("body").addClass("modal-open");
        $("header").siblings().attr("aria-hidden", "true");
        getSuggestionsWrapper(scope).find(".suggestions").addClass("modal");
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    $("input.search-field").val("");
    clearModals();
    $(".search-mobile .suggestions").unbind("scroll");
    $(".suggestions-wrapper").empty();
    announceSearchStatus("");
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = ".search-mobile button.";
    var iconSearch = "fa-search";
    var iconSearchClose = "fa-close";

    if (action === "close") {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr("type", "button");
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr("type", "submit");
    }
}

/**
 * Determines whether the "More Content Below" icon should be displayed
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function handleMoreContentBelowIcon(scope) {
    var $scope = $(scope);
    var $moreBelow = $(".more-below");

    if (($scope.scrollTop() + $scope.innerHeight()) >= $scope[0].scrollHeight) {
        $moreBelow.fadeOut();
    } else {
        $moreBelow.fadeIn();
    }
}

/**
 * Positions Suggestions panel on page
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 */
function positionSuggestions(scope) {
    let outerHeight;
    let $scope = $(scope);
    let $suggestions;
    let top;
    let $header = $scope.closest(".l-header");

    if($header.length) {
        let totalBorderWidth = parseInt($header.css("border-bottom-width"), 10) + parseInt($header.css("border-top-width"), 10)
        getSuggestionsWrapper(scope).css("top", Math.floor($header.height() + totalBorderWidth));

        return;
    }

    if (isMobileSearch(scope)) {
        top = $scope.offset().top;
        outerHeight = $scope.outerHeight();
        $suggestions = getSuggestionsWrapper(scope).find(".suggestions");
        $suggestions.css("top", top + outerHeight);

        handleMoreContentBelowIcon(scope);

        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
        // properly detecting dynamic suggestions element's scroll event
        $suggestions.scroll(function () {
            handleMoreContentBelowIcon(this);
        });
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    let $htmlElement = $("html");

    $.spinner().stop();

    if (typeof (response) !== "object") {
        $suggestionsWrapper.append(response).show();
        $(".reset-button").addClass("d-block");
        positionSuggestions(this);
        lazyLoading.refreshLazyLoadingFeature();

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon("close");
            applyModals(this);
        }

        // Only mutate the attribute when needed; re-setting an unchanged value can make
        // some screen readers re-announce name+description on top of our own live region.
        if ($("input.search-field").attr("aria-describedby") !== "search-result-count") {
            $("input.search-field").attr("aria-describedby", "search-result-count");
        }
        updateSearchPopupState(this, true);
        $htmlElement.addClass("search-focused");
        $("body").trigger("search:response");
    } else {
        $suggestionsWrapper.hide();
        updateSearchPopupState(this, false);
        $htmlElement.removeClass("search-focused");
    }

    // Scope to the wrapper just rendered; a document-wide selector can pick up stale
    // or duplicate result-count elements from other search widgets on the page.
    var resultCountMessage = $suggestionsWrapper.find(".js-search-result-count").text().trim();
    announceSearchStatus(resultCountMessage);
}

/**
 * Retrieve suggestions
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    let $htmlElement = $("html");
    let $scopeVal = $(scope).val();
    let $searchSubmitButton = $(".l-header__search-submit-button");
    let $resetButton = $(".reset-button");

    if ($scopeVal.length >= minChars) {
        $.spinner().start();
        $.ajax({
            context: scope,
            url: endpoint + encodeURIComponent($scopeVal),
            method: "GET",
            success: processResponse,
            error: function () {
                $.spinner().stop();
            }
        });
        $searchSubmitButton.addClass("d-none");
        $resetButton.addClass("d-block");
        $htmlElement.find(".l-header__search-field").addClass("l-header__search-field-focused");
        $htmlElement.addClass("search-focused");
        $("body").toggleClass("modal-open", true);
    } else {
        if ($scopeVal.length && $scopeVal.length < minChars) {
            $searchSubmitButton.addClass("d-none");
            $htmlElement.find(".l-header__search-field").addClass("l-header__search-field-focused");
            $resetButton.addClass("d-block");
            clearModals();
            getSuggestionsWrapper(scope).empty();
            $htmlElement.removeClass("search-focused");
            updateSearchPopupState(scope, false);
            announceSearchStatus("");
        } else {
            toggleSuggestionsIcon("search");
            $resetButton.removeClass("d-block");
            $htmlElement.find(".l-header__search-field").removeClass("l-header__search-field-focused");
            $searchSubmitButton.removeClass("d-none");
            updateSearchPopupState(scope, false);
            announceSearchStatus("");
        }

        $("body").toggleClass("modal-open", false);
    }

    $htmlElement.find(".l-header__search-field").val($scopeVal);
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $(".suggestions .item");
    if (suggestionsList.filter(".selected").length === 0) {
        suggestionsList.first().addClass("selected");
        $("input.search-field").each(function () {
            $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            var $this = $(this);
            var $inputSearchField = $("input.search-field");

            if ($this.hasClass("selected")) {
                $this.removeClass("selected");
                $this.removeAttr("aria-selected");
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass("selected");
                    suggestionsList.eq(idx).attr("aria-selected", true);
                    $this.removeProp("aria-selected");
                    $inputSearchField.each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass("selected");
                    suggestionsList.first().attr("aria-selected", true);
                    $inputSearchField.each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

/**
   Prevent submit of the search form when there is no value typed in the search input field
    */

const emptySearchValue = () => {
    let searchSubmitButton = document.querySelector(".l-header__search-submit-button");
    let searchFieldInput = document.querySelector(".l-header__search-field");

    searchSubmitButton.addEventListener("click", function (e) {
        if (!searchFieldInput.value) {
            e.preventDefault();
        }
    });
};

module.exports = function () {
    let $htmlElement = $("html");
    let searchSubmitButton = document.querySelector(".l-header__search-submit-button");
    const $body = $("body");

    $("form[name=\"simpleSearch\"]").submit(function (e) {
        var suggestionsList = $(".suggestions .item");

        if (suggestionsList.filter(".selected").length !== 0) {
            e.preventDefault();
            suggestionsList.filter(".selected").find("a")[0].click();
        }
    });

    $("input.search-field").each(function () {
        /**
         * Use debounce to avoid making an Ajax call on every single key press by waiting a few
         * hundred milliseconds before making the request. Without debounce, the user sees the
         * browser blink with every key press.
         */
        var debounceSuggestions = debounce(getSuggestions, 300);
        $(this).on("keyup focus", function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                default:
                    debounceSuggestions(this, e);
            }
        });
    });

    $body.on("click", function (e) {
        var $suggestions = $(".suggestions");

        if (!$suggestions.has(e.target).length && !$(e.target).hasClass("search-field") && !$(".l-header__sticky-search-button").has(e.target).length) {
            $suggestions.hide();
            $("input.search-field").each(function () {
                updateSearchPopupState(this, false);
            });
            $htmlElement.removeClass("search-focused");
            $("body").toggleClass("modal-open", false);
        }
    });

    $body.on("click touchend", ".search-mobile button.fa-close", function (e) {
        e.preventDefault();

        $(".suggestions").hide();
        $("input.search-field").each(function () {
            updateSearchPopupState(this, false);
        });
        $htmlElement.removeClass("search-focused");
        toggleSuggestionsIcon("search");
        tearDownSuggestions();
        $("body").toggleClass("modal-open", false);
    });

    $(".site-search .reset-button").on("click", function () {
        var $htmlElementSearchField = $htmlElement.find(".l-header__search-field");

        $(".reset-button").removeClass("d-block");
        $htmlElementSearchField.removeClass("l-header__search-field-focused");
        $(".l-header__search-submit-button").removeClass("d-none");
        $("input.search-field").each(function () {
            updateSearchPopupState(this, false);
        });
        $htmlElementSearchField.val("");
    });

    if (searchSubmitButton) {
        emptySearchValue();
    }
};
